export const getHealthStatusAction = () => {
    return { type: "GET_HEALTH_STATUS_ACTION" };
};

export const getHealthStatusData = (data) => {
    return { type: "SUCCESSFULLY_GET_HEALTH_STATUS_DATA", payload: data };
};

export const getHealthStatusError = (error) => {
    return { type: "GET_HEALTH_STATUS_ERROR", payload: error };
};
